import PropTypes from "prop-types"

import { cn } from "styles/utils"

const Image = ({
  alt,
  className,
  fallback,
  lazyload,
  src,
  srcSet,
  ...props
}) => {
  return (
    <img
      alt={alt || ""}
      className={cn(className, lazyload && "lazyload")}
      {...(lazyload
        ? {
            "data-src": src,
            "data-srcset": srcSet,
            src: fallback || "https://assets.jewlr.com/icons/jewlr.gif",
          }
        : {
            src,
            srcSet,
          })}
      {...props}
    />
  )
}

Image.defaultProps = {
  lazyload: true,
}

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  fallback: PropTypes.string,
  lazyload: PropTypes.bool,
  src: PropTypes.string,
  srcSet: PropTypes.string,
}

Image.displayName = "Image"

export default Image
